import { render } from "./DepositFormPaychangu.vue?vue&type=template&id=1e668f84&scoped=true"
import script from "./DepositFormPaychangu.vue?vue&type=script&lang=js"
export * from "./DepositFormPaychangu.vue?vue&type=script&lang=js"

import "./DepositFormPaychangu.vue?vue&type=style&index=0&id=1e668f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e668f84"]])

export default __exports__